// removed by extract-text-webpack-plugin
module.exports = {"Home":"___Home__Home___RV_UW","Callout":"___Home__Callout___jroUz"};


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Home/Home.less
// module id = 1024
// module chunks = 0